<template>
  <div class="incubation-page">
    <!-- 顶部横幅部分 -->
    <div class="section-banner">
      <div class="content">
        <h1>项目孵化</h1>
        <p>提供全方位的项目孵化服务，从创意初期到市场落地，助力创业团队快速成长。我们整合资金、人才、技术和市场资源，为创新项目提供专业孵化支持，促进创新成果转化。</p>
        <div class="actions">
          <el-button class="btn-yellow" type="primary">了解详情</el-button>
          <el-button class="btn-dark" type="primary">&gt;</el-button>
        </div>
      </div>
    </div>

    <!-- 服务卡片部分 -->
    <div class="service-cards">
      <!-- 卡片1 -->
      <div class="service-card">
        <div class="card-image">
          <img src="https://echance.oss-cn-beijing.aliyuncs.com/incubation-bg2.png" alt="创业项目评估">
        </div>
        <div class="card-content">
          <h2>创业项目评估</h2>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>我们拥有专业的项目评估团队，对创业项目进行全面深入的市场潜力、技术可行性和商业模式评估，帮助创业者明确项目优势与不足。</p>
            </div>
          </div>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>通过科学的评估体系，为项目提供客观的市场定位和发展建议，降低创业风险，提高项目成功率。</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 卡片2 -->
      <div class="service-card">
        <div class="card-content">
          <h2>资源整合对接</h2>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>依托我们丰富的产业资源网络，为创业项目提供资金、技术、市场、渠道等多方面资源对接服务，解决创业过程中的关键痛点。</p>
            </div>
          </div>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>搭建企业与投资机构、政府部门、研发机构的桥梁，促进多方合作，实现资源的高效配置与整合，加速项目发展。</p>
            </div>
          </div>
        </div>
        <div class="card-image">
          <img src="https://echance.oss-cn-beijing.aliyuncs.com/incubation-bg3.png" alt="资源整合对接">
        </div>
      </div>

      <!-- 卡片3 -->
      <div class="service-card">
        <div class="card-image">
          <img src="https://echance.oss-cn-beijing.aliyuncs.com/incubation-bg4.png" alt="创业指导培训">
        </div>
        <div class="card-content">
          <h2>创业指导培训</h2>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>提供系统化的创业培训课程，覆盖商业计划书撰写、融资策略、团队建设、营销推广等创业全过程的关键环节。</p>
            </div>
          </div>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>邀请行业专家和成功创业者分享经验，为创业团队提供针对性指导，帮助他们避开常见陷阱，加速成长。</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 卡片4 -->
      <div class="service-card">
        <div class="card-content">
          <h2>成果转化落地</h2>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>专注于科技成果转化和产业化过程，提供从技术验证、产品开发到市场推广的全流程支持，加速创新成果商业化。</p>
            </div>
          </div>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>协助项目对接产业应用场景，提供试点示范机会，促进技术与市场的有效结合，实现创新价值最大化。</p>
            </div>
          </div>
        </div>
        <div class="card-image">
          <img src="https://echance.oss-cn-beijing.aliyuncs.com/incubation-bg5.png" alt="成果转化落地">
        </div>
      </div>
    </div>

    <!-- 服务咨询部分 -->
    <div class="section-contact">
      <div class="contact-content">
        <h2>开启专属服务<br>获取更大价值</h2>
        <el-form class="contact-form" :model="contactForm" :rules="contactRules" ref="contactForm">
          <el-input v-model="contactForm.name" placeholder="您的姓名"></el-input>
          <el-input v-model="contactForm.mobile" placeholder="手机号码"></el-input>
          <div class="actions">
            <el-button class="btn-yellow" type="primary" @click="submitContactForm">Services</el-button>
            <el-button class="btn-dark" type="primary">&gt;</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { saveUserRequirementApi } from '@/api/index';

export default {
  name: 'IncubationPage',
  data() {
    return {
      contactForm: {
        name: '',
        mobile: '',
        companyName: '测试公司名称',
        demandType: '4' // 项目孵化服务类型
      },
      contactRules: {
        name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitContactForm() {
      // 判断姓名和手机号是否为空
      if (!this.contactForm.name || this.contactForm.name.trim() === '') {
        this.$message.error('请输入您的姓名');
        return;
      }
      if (!this.contactForm.mobile || this.contactForm.mobile.trim() === '') {
        this.$message.error('请输入手机号码');
        return;
      }
      
      this.$refs.contactForm.validate(valid => {
        if (valid) {
          saveUserRequirementApi(this.contactForm).then(res => {
            this.$message.success('提交成功');
            this.contactForm.name = '';
            this.contactForm.mobile = '';
          }).catch(err => {
            this.$message.error('提交失败，请稍后重试');
            console.error(err);
          });
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.incubation-page {
  width: 100%;
  background-color: #fff;
  color: #333;
}

// 顶部横幅
.section-banner {
  height: 1080px;
  background-image: url('https://echance.oss-cn-beijing.aliyuncs.com/incubation-bg.png');
  background-size: cover;
  background-position: center;
  display: flex;
  color: #fff;

  .content {
    width: 1200px;
    margin: 0 auto;
    padding-top: 345px;

    h1 {
      font-weight: bold;
      font-size: 78px;
      line-height: 92px;
      margin-bottom: 30px;
    }

    p {
      font-size: 17px;
      font-weight: bold;
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      line-height: 25px;
      margin-bottom: 70px;
      max-width: 700px;
    }

    .actions {
      display: flex;

      .btn-yellow {
        background-color: #ffc107;
        border-color: #ffc107;
        color: #0F0FB1;
        width: 150px;
        height: 50px;
        font-size: 20px;
        font-weight: bold;
        line-height: 22px;
      }
      
      .btn-dark {
        background-color: #002366;
        border-color: #002366;
        color: #fff;
        width: 50px;
        height: 50px;
        margin-left: -5px;
      }
    }
  }
}

// 服务卡片区域
.service-cards {
  width: 1200px;
  margin: 80px auto;
}

.service-card {
  display: flex;
  justify-content: space-between;
  margin-bottom: 80px;

  .card-image {
    width: 45%;
    img {
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  }

  .card-content {
    width: 45%;
    padding: 20px 0;

    h2 {
      font-weight: bold;
      font-size: 32px;
      color: #19456B;
      line-height: 42px;
      margin-bottom: 30px;
    }

    .feature {
      display: flex;
      margin-bottom: 20px;

      .feature-icon {
        color: #4CAF50;
        font-size: 20px;
        margin-right: 10px;
        margin-top: 2px;
      }

      .feature-text {
        p {
          font-size: 17px;
          color: #382933;
          line-height: 25px;
          margin: 0;
        }
      }
    }
  }
}

// 服务咨询部分
.section-contact {
  margin: 0 auto 100px;
  width: 1200px;
  height: 340px;
  box-sizing: border-box;
  padding: 40px;
  background-image: url('https://echance.oss-cn-beijing.aliyuncs.com/bg-contact.png');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;

  .contact-content {
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    h2 {
      font-weight: bold;
      font-size: 48px;
      color: #FFFFFF;
      line-height: 52px;
    }

    .contact-form {
      display: block;

      .el-input {
        width: 350px;
        display: block;
        margin-bottom: 25px;

        ::v-deep .el-input__inner {
          background-color: transparent;
          border: none;
          border-bottom: 2px solid rgba(255, 255, 255, 0.5);
          border-radius: 0;
          padding-left: 0;
          height: 50px;
          font-size: 24px;
          color: #FFFFFF;
          line-height: 24px;

          &:focus {
            border-bottom-color: #fff;
          }

          &::placeholder {
            color: #ccc;
            font-size: 24px;
          }
        }
      }

      .actions {
        display: flex;

        .btn-yellow {
          background-color: #ffc107;
          border-color: #ffc107;
          color: #0F0FB1;
          width: 150px;
          height: 50px;
          font-size: 20px;
          font-weight: bold;
          line-height: 22px;
        }

        .btn-dark {
          background-color: #002366;
          border-color: #002366;
          color: #fff;
          width: 50px;
          height: 50px;
          margin-left: -5px;
        }
      }
    }
  }
}
</style>